import React, { useEffect, useRef } from 'react';
import classes from './style.module.scss';
import ListItem from './ListItem';
import { useStoreState } from '~/store';
import { MessageType, selectChatData } from '~/app/data/statuses/chat';
import { Message } from '~/types';

export interface ListProps {
    type: MessageType;
    className?: string;
}

export type ListComponent = React.FC<ListProps>;

const getSenderKey = (item: Message): string => String(item.senderId || item.user || '');

const List: ListComponent = ({ type, className }) => {
    const chat = useStoreState(state => selectChatData(state, type).chat ?? []);
    const currentUserId = useStoreState(state => String(state.user.data?.id ?? ''));
    const messagesEndRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
        }
    }, [chat, messagesEndRef])

    return (
        <div
            className={[classes.messages, className].filter(Boolean).join(' ')}
            ref={messagesEndRef}
        >
            {chat.map((item, index) => {
                const isAction = !!item.actions;
                const prev = chat[index - 1];
                const next = chat[index + 1];
                const senderKey = getSenderKey(item);
                const isOwn = !isAction && senderKey !== '' && senderKey === currentUserId;

                const sameSenderAsPrev = !isAction && !!prev && !prev.actions && getSenderKey(prev) === senderKey;
                const sameSenderAsNext = !isAction && !!next && !next.actions && getSenderKey(next) === senderKey && !next.showDate;

                const isFirstInGroup = isAction || !sameSenderAsPrev || !!item.showDate;
                const isLastInGroup = isAction || !sameSenderAsNext;

                return (
                    <ListItem
                        key={index}
                        item={item}
                        isOwn={isOwn}
                        isFirstInGroup={isFirstInGroup}
                        isLastInGroup={isLastInGroup}
                    />
                );
            })}
        </div>
    );
};

export default List
